import type { ReactNode } from 'react'

interface Props {
  text: ReactNode
}

export const TimeBox = ({ text }: Props) => {
  return (
    <div className="flex h-[20px] w-[28px] items-center justify-center rounded-md text-sm font-medium text-white">
      {text}
    </div>
  )
}
